export default __webpack_public_path__ + "static/media/caret-up-solid.eccba66f.svg";